import React, { useState } from "react";
import Slider from "react-slick";
import { HiArrowRight, HiArrowLeft } from "react-icons/hi";
import Title from "../layouts/Title";
import scholarDenLogo from "../../assets/images/testmonial/scholar_den_logo.jpeg";
import codeKrakenLogo from "../../assets/images/testmonial/code_kraken_logo.jpeg";
import quote from "../../assets/images/testmonial/quote.png";

const data = [
  {
    name: "CEO, Scholarden",
    img: scholarDenLogo,
    quote:
      "kashif is a skilled full-stack developer who delivers high-quality web solutions. Their expertise in frontend and backend ensures seamless performance. Professional, detail-oriented, and reliable—highly recommended!",
  },
  {
    name: "CEO, Code Kraken",
    img: codeKrakenLogo,
    quote:
      "Exceptional work by kashif! A talented full-stack developer who builds fast, secure, and user-friendly web solutions. Highly professional and great to work with!",
  },
];
function SampleNextArrow(props) {
  const { onClick } = props;
  return (
    <div
      className="w-14 h-12 dark:bg-[#0c1821] bg-white dark:hover:bg-black duration-300 rounded-md text-2xl text-black dark:text-gray-400 flex justify-center items-center absolute top-0 right-0 shadow-shadowOne dark:shadow-[#1c1e22] shadow-gray-200 cursor-pointer z-10"
      onClick={onClick}
    >
      <HiArrowRight />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { onClick } = props;
  return (
    <div
      className="w-14 h-12 dark:bg-[#0c1821] bg-white dark:hover:bg-black duration-300 rounded-md text-2xl text-black dark:text-gray-400 flex justify-center items-center absolute top-0 right-20 shadow-shadowOne dark:shadow-[#1c1e22] shadow-gray-200 cursor-pointer z-10"
      onClick={onClick}
    >
      <HiArrowLeft />
    </div>
  );
}

const Testimonial = () => {
  const [dotActive, setDocActive] = useState(0);
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    beforeChange: (prev, next) => {
      setDocActive(next);
    },
    appendDots: (dots) => (
      <div
        style={{
          borderRadius: "10px",
          padding: "10px",
        }}
      >
        <ul
          style={{
            display: "flex",
            gap: "15px",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          {" "}
          {dots}{" "}
        </ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        style={
          i === dotActive
            ? {
                width: "12px",
                height: "12px",
                color: "blue",
                background: "green",
                borderRadius: "50%",
                cursor: "pointer",
              }
            : {
                width: "12px",
                height: "12px",
                color: "blue",
                background: "gray",
                borderRadius: "50%",
                cursor: "pointer",
              }
        }
      ></div>
    ),
  };
  return (
    <section
      id="testimonial"
      className="w-full py-20 border-b-[1px] dark:border-b-gray-600"
    >
      <div className="flex justify-center items-center text-center">
        <Title title="WHAT PEOPLE SAY" des="Quotes" />
      </div>
      <div className="max-w-6xl mx-auto">
        <Slider {...settings}>
          {data.map((item, index) => {
            return (
              <div key={index} className="w-full">
                <div className="w-[80%] mx-auto h-auto flex flex-col justify-between">
                  <img className="w-[100px]" src={quote} alt="quote" />
                  <div className=" h-full flex flex-col justify-between md:items-start items-center my-5">
                    <div className="w-full h-[70%] py-10 bg-gradient-to-r  from-[#fdfdfd] to-[#fafafa] dark:from-[#1e2024] dark:to-[#23272b] rounded-lg shadow-shadowOne dark:shadow-[#1c1e22] shadow-gray-200 p-4 lgl:p-8 flex flex-col justify-center">
                      <p className="text-base font-titleFont text-gray-400 font-medium tracking-wide leading-6">
                        "{item.quote}"
                      </p>

                      <p className="text-sm dark:text-designColor text-blue-600 font-semibold tracking-wide mb-2 mt-2">
                        Said by
                      </p>
                      <div className="flex items-center">
                        <img
                          className="sm:h-[50px] sm:w-[50px] w-[30px] h-[30px] object-fill rounded-full mr-2"
                          src={item.img}
                          alt="testimonialOne"
                        />
                        <h3 className="sm:text-2xl text-lg  font-bold">
                          {item.name}
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </section>
  );
};

export default Testimonial;
